import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { ComboboxFieldComponent } from '@app/common/configurable-wizards/fields/SingleChoice/Combobox/ComboboxFieldComponent';
import {
  SingleChoiceFieldFragment as SingleChoiceField,
} from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import {
  FieldComponent,
  FieldLocator,
} from '@app/common/configurable-wizards/types';
import { isSingleChoiceField } from '@app/common/configurable-wizards/utils/fieldTypesCheck';
import { DEFAULT_COUNTRY } from '@app/common/types/locales';

import { COUNTRY_FIELD_NAME, useAddressFormContext } from '../../contexts/AddressFormContext';

export const CountryFieldComponent: FieldComponent<SingleChoiceField> = ({ parent, field, locator }) => {
  const { watch } = useFormContext();
  const currentCountry = watch(`${parent}.${COUNTRY_FIELD_NAME}`) || field.selectedValue;
  const { isForeignAddressEnabled, setIsApoFpoEnabled, setCountry } = useAddressFormContext();

  useEffect(() => {
    if (isForeignAddressEnabled) {
      setIsApoFpoEnabled(currentCountry === DEFAULT_COUNTRY);

      if (currentCountry) {
        setCountry(currentCountry);
      }
    }
  }, [currentCountry]);

  return (
    <ComboboxFieldComponent
      parent={parent}
      field={field}
      locator={locator}
    />
  );
};

export const CountryFieldLocator: FieldLocator = (context) => (
  isSingleChoiceField(context.field) && context.field.id === 'Country'
    ? CountryFieldComponent
    : undefined
);
